"use strict";
import _ from 'lodash';
import cached from '../../../../../cachedData/colors';

function getInitialState () {
	return _.keyBy(cached.collections.colorCollection.list, 'colorId');
}

export default {getInitialState};
